/******************************************************************************
 *
 * Copyright (c) 2019-2022 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Shivam Mishra' <shivam.mishra@wakencode.com>, September 2022
 *
 *****************************************************************************/

import { FONT_SIZE } from "./model/constants/font-size";
import { COLOR } from "./model/constants/color";
import { FONT_FAMILY } from "./model/constants/font-family";
import { PADDING } from "./model/constants/padding";
import { MARGIN } from "./model/constants/margin";

export const globleStyles = {
  cardTitle: {
    fontSize: FONT_SIZE.FONT_SIZE_TWENTY_FOUR,
    color: COLOR.CHINESE_BLACK,
    fontFamily: FONT_FAMILY.FONT_FAMILY_BOLD,
  },

  cardBody: {
    fontSize: FONT_SIZE.FONT_SIZE_TWELVE,
    color: COLOR.PHILIPPINE_GRAY,
    fontFamily: FONT_FAMILY.FONT_FAMILY_DEMI,
    lineHeight: "initial",
  },

  cardTitleSubText: {
    fontFamily: FONT_FAMILY.FONT_FAMILY_REGULAR,
    fontSize: FONT_SIZE.FONT_SIZE_FOURTEEN,
    color: COLOR.PHILIPPINE_GRAY,
  },

  popUpInsideHeader: {
    color: COLOR.DAVYS_GREY,
    fontFamily: FONT_FAMILY.FONT_FAMILY_BOLD,
    fontSize: FONT_SIZE.FONT_SIZE_EIGHTEEN,
  },

  popUpInsideRegularText: {
    fontSize: FONT_SIZE.FONT_SIZE_FOURTEEN,
    color: COLOR.PHILIPPINE_GRAY,
    fontFamily: FONT_FAMILY.FONT_FAMILY_REGULAR,
  },

  detailsField: {
    fontSize: FONT_SIZE.FONT_SIZE_FOURTEEN,
    fontFamily: FONT_FAMILY.FONT_FAMILY_REGULAR,
    color: COLOR.SLATE_GRAY,
  },
  detailsValue: {
    fontSize: FONT_SIZE.FONT_SIZE_FOURTEEN,
    fontFamily: FONT_FAMILY.FONT_FAMILY_DEMI,
    color: COLOR.GUNMETAL,
  },

  helperText: {
    fontSize: FONT_SIZE.FONT_SIZE_TWELVE,
    fontFamily: FONT_FAMILY.FONT_FAMILY_DEMI,
    color: COLOR.ILLUMINATING_EMERALD,
  },

  cardFieldStyles: {
    fontSize: FONT_SIZE.FONT_SIZE_FOURTEEN,
    fontFamily: FONT_FAMILY.FONT_FAMILY_DEMI,
    color: COLOR.RICH_BLACK,
  },
  
  // Table data styles
  tableMainText: {
    fontSize: FONT_SIZE.FONT_SIZE_FOURTEEN,
    fontFamily: FONT_FAMILY.FONT_FAMILY_DEMI,
    color: COLOR.LIGHT_BLACK,
  },
  tableSecondaryText: {
    fontSize: FONT_SIZE.FONT_SIZE_FOURTEEN,
    fontFamily: FONT_FAMILY.FONT_FAMILY_REGULAR,
    color: COLOR.LIGHT_BLACK
  },
 
  viewEdit: {
    fontSize: FONT_SIZE.FONT_SIZE_FOURTEEN,
    fontFamily: FONT_FAMILY.FONT_FAMILY_REGULAR,
    color: COLOR.ILLUMINATING_EMERALD,
    lineHeight: "17px",
    fontStyle: "italic",
    fontWeight: 400,
  },

  halfWidthCardStyles: {
    width: "49%",
    backgroundColor: COLOR.WHITE,
    padding: PADDING.PADDING_SIXTEEN,
    borderRadius: MARGIN.MARGIN_EIGHT,
  },
  

  flexSpaceBetweenTBM8PX: {
    margin: "8px 0",
    display: "flex",
    justifyContent: "space-between",
  },

  inputHeaderText: {
    fontSize: FONT_SIZE.FONT_SIZE_FOURTEEN,
    color: COLOR.DARK_GREY,
    fontFamily: FONT_FAMILY.FONT_FAMILY_DEMI,
  },

  halfInputPopUp: {
    width: "212px",
  },

  popUpFooter: {
    display: "flex",
    justifyContent: "flex-end",
    margin: "16px 0 0 0",
  },
  popUpFooterWithBackButton: {
    display: "flex",
    justifyContent: "space-between",
    margin: "16px 0 0 0",
  },
  popUpNextButton: {
    backgroundColor: "#3a9f6b",
    borderRadius: "8px",
    fontWeight: "bold",
    padding: "4px 32px",
  },
  popUpBackButton: {
    color: "#3a9f6b",
    borderRadius: "8px",
    fontWeight: "bold",
    padding: "4px 32px",
    border: "1px solid #3a9f6b",
  },
  popUpDefaultButton: {
    color: "#3a9f6b",
    fontWeight: "bold",
    padding: "4px 32px",
    border: 0,
  },
};
